import Vue  from "vue";
import VueRouter from "vue-router";
import messageBox from "element-ui/packages/message-box";
import {doPost} from "@/utils/http";


Vue.use(VueRouter)

const routes = [
    {
        path: "/home",
        redirect: "/sampleList",
        component: () => import("@/views/home/Home"),
        children: [
            {
                path: "/sampleList",
                name: "SampleList",
                component: () => import("@/views/sample/SampleList"),
                meta: {
                    componentsName: "选购样品",
                },
            },
            {
                path: "/accountInfo",
                name: "AccountInfo",
                component: () => import("@/views/account/AccountInfo"),
                meta: {
                    componentsName: "账户信息",
                },
            },
            {
                path: "/receiveInfo",
                name: "ReceiveInfo",
                component: () => import("@/views/account/ReceiveInfo"),
                meta: {
                    componentsName: "收货信息",
                },
            },
            {
                path: "/cart",
                name: "Cart",
                component: () => import("@/views/sample/Cart"),
                meta: {
                    componentsName: "购物车",
                },
            },
            {
                path: "/sampleOrder",
                name: "SampleOrder",
                component: () => import("@/views/sample/SampleOrder"),
                meta: {
                    componentsName: "我的订单",
                },
            },
            {
                path: "/sampleOrderDetail",
                name: "SampleOrderDetail",
                component: () => import("@/views/sample/SampleOrderDetail"),
                meta: {
                    componentsName: "样品订单详情",
                },
            },
            {
                path: "/admin/Orders",
                name: "admin-orders",
                component: () => import("@/views/admin/Orders"),
                meta: {
                    componentsName: "所有订单",
                },
            },
            {
                path: "/admin/Users",
                name: "admin-users",
                component: () => import("@/views/admin/Users"),
                meta: {
                    componentsName: "所有用户",
                },
            },
            {
                path: "/admin/Statement",
                name: "admin-users",
                component: () => import("@/views/admin/Statement"),
                meta: {
                    componentsName: "对账单列表",
                },
            },
            {
                path: "/permission/userLimit",
                name: "permission-userLimit",
                component: () => import("@/views/permission/UserLimit"),
                meta: {
                    componentsName: "用户限制",
                },
            },
            {
                path: "/permission/userPermission",
                name: "permission-userPermission",
                component: () => import("@/views/permission/UserPermission"),
                meta: {
                    componentsName: "账户权限配置",
                },
            }
        ]
    },
    {
        path: "/preOrder",
        name: "PreOrder",
        component: () => import("@/views/sample/PreOrder"),
        meta: {
            componentsName: "订单结算页",
        },
    },
    {
        redirect:"/login",
        path: "/",
        name: "Login",
        component: () => import("@/views/login/Login"),
        meta: {
            componentsName: "登录",
        },
        children: [
            {
                path: "/login",
                name: "Login",
                component: () => import("@/views/login/Login"),
                meta: {
                    componentsName: "登录",
                },
            },
            {
                path: "/admin/Statement",
                name: "admin-statement",
                component: () => import("@/views/admin/Statement.vue"),
                meta: {
                    componentsName: "所有订单",
                },
            },
        ]
    },
    {
        path: "/registrationAgreement",
        name: "RegistrationAgreement",
        component: () => import("@/views/login/RegistrationAgreement"),
        meta: {
            componentsName: "注册服务协议",
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    base:
        process.env.NODE_ENV === "production" || process.env.NODE_ENV === "dev"
            ? "/sampleui"
            : "/",
    routes
})

router.beforeEach((to, from, next) => {
    if (to.path === "/Login" || to.path === "/register" || to.path === "/forgetPassword" || to.path === "/registrationAgreement") {
        next();
    } else {
        let token = localStorage.getItem("token");
        if (token === null || token === undefined || token.length === 0) {
            // messageBox.confirm('请先登录！', '提示', {
            //     confirmButtonText: '确定',
            //     showCancelButton: false,
            //     showClose: false,
            //     closeOnClickModal: false,
            //     type: 'warning'
            // }).then(() => {
            //     next("/Login");
            // });
            next("/Login");
        } else {
            next();
        }
    }
})

export default router